module.exports = __webpack_public_path__ + "static/media/bits.1ff69b19.svg";